export default __webpack_public_path__ + "static/media/logoColored.e71f6af2.png";